<template>
	<button
		v-if="slots?.trigger != null"
		ref="floatingRef"
		@click="setShowCustomElement"
	>
		<slot
			name="trigger"
			:open="showFloatingElement"
		/>
	</button>

	<Teleport to="#tooltips-container">
		<div
			v-if="showFloatingElement"
			ref="floating"
			class="z-9999"
			:style="{
				...floatingStyles,
				visibility: middlewareData?.hide?.referenceHidden ? 'hidden' : 'visible',
			}"
		>
			<slot :open="showFloatingElement" />
		</div>
	</Teleport>
</template>

<script setup>
import { ref, toRefs, Teleport, useSlots, shallowRef } from 'vue';
import { useFloating, flip, offset, autoUpdate, hide } from '@floating-ui/vue';

import { useMouse, onClickOutside } from '@vueuse/core';

const slots = useSlots();
const { x, y } = useMouse();

const props = defineProps({
	placement: {
		type: String,
		default: 'bottom-center',
	},
});
const { placement } = toRefs(props);

const floatingRef = ref(null);
const floating = ref(null);
const showFloatingElement = shallowRef(false);

const setShowCustomElement = (event) => {
	showFloatingElement.value = !showFloatingElement.value;
};

const hideFloatingElement = () => {
	showFloatingElement.value = false;
};

onClickOutside(floatingRef, hideFloatingElement);

const { floatingStyles, middlewareData } = useFloating(floatingRef, floating, {
	placement: placement.value,
	middleware: [flip(), offset(4), hide()],
	whileElementsMounted(...args) {
		return autoUpdate(...args, { animationFrame: true });
	},
});
</script>
